import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const appDirectoryRoutes: Routes = [
  {
    path: 'directorio-app',
    loadComponent: () =>
      import('./app-directory.component').then((c) => c.AppDirectoryComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'archivos',
    loadComponent: () =>
      import('./pages/files/files.component').then((c) => c.FilesComponent),
    canActivate: [AuthGuard],
  },
];
